module.exports = __webpack_public_path__ + "static/media/LI.654b8bca.png";